import React, { useState, useEffect, useCallback } from 'react';
import { Popover } from "@mui/material";

import Grid from '@mui/material/Grid2';

import { 
  RollPlus,
  AbilityEffect,
  Creature,
  BasicCreatureInstance,
  Potence,
  Transform,
  // Adaptation,
  CreatureTransform,
  CharacterFeature,
  Spell,
  RolledValue,
  SummonOption2,
  CreatureAbility,
  DamageTypeOverrides,
  iCreatureSpell,
  ComplexCreatureInstance
} from "@dndModels";
// import { SmartHash } from '../../../../../models';

// import API from "../../../utilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import CommonUtilities from "@utilities/common_utilities";

import DandDButtonBox from "@dndComponents/DandDButtonBox";

import Roller from "@dndComponents/other/Roller";
import DisplayObjects from "@dndComponents/display/DisplayObjects";
import SelectObjectBox from "@components/input/selects/SelectObjectBox";
import LoadingBox from "@components/input/LoadingBox";
// import ViewItem from '../../display/ViewItem';
import ImageFromString from "@dndComponents/display/ImageFromString";
import CharacterSummonOptions from "@dndComponents/character/misc/CharacterSummonOptions";
import CharacterRollableTableEffect from "@dndComponents/character/spells_and_abilities/effects/CharacterRollableTableEffect";
import { isSpellLevel } from '@dndModels/Types';

interface Props {
  creature_instance: BasicCreatureInstance | ComplexCreatureInstance;
  action?: CreatureAbility;
  dt_overrides?: DamageTypeOverrides[];
  spell?: Spell;
  c_spell?: iCreatureSpell;
  effect: AbilityEffect;
  processing: boolean;
  disabled: boolean;
  log_it?: boolean;
  ee_cf?: CharacterFeature;
  type_cf?: CharacterFeature;
  shared: boolean;
  level: number;
  wide: boolean;
  show_extra_effects?: boolean;
  show_range?: boolean;
  attack_mod?: number;
  casting_time: string; // 'A' | 'BA' | 'RA' | 'Special' | 'Attack' | "1 Minute" | "10 Minutes" | "1 Hour";
  onChange: (change_types: string[]) => void; // For slots, resources, and concentration
  onCostChange: (costs: { [resource: string]: number }) => void;
  onTransform: () => void;
  onSummon: (selected_option: SummonOption2) => void;
}

// const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const common_util = CommonUtilities.getInstance();

export default function CreatureEffect({
  creature_instance,
  action,
  dt_overrides = [],
  spell,
  c_spell,
  effect,
  processing,
  disabled,
  log_it = false,
  show_range = true,
  ee_cf,
  type_cf,
  shared,
  level,
  wide,
  show_extra_effects = false,
  attack_mod = 0,
  casting_time,
  onChange,
  onCostChange,
  onTransform,
  onSummon
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reloading, setReloading] = useState(false);
  // const [transforms, setTransforms] = useState<Transform[]>([]);
  // const [adaptations, setAdaptations] = useState<Adaptation[]>([]);
  const [popoverAnchorEl, setPopoverAnchorEl] = useState<HTMLDivElement | null>(null);
  const [popoverEffect, setPopoverEffect] = useState<AbilityEffect | null>(null);
  const [popoverMode, setPopoverMode] = useState("null");
  const [is_processing, setProcessing] = useState(false);
  // const [ping, setPing] = useState(false);
  // const [keep_rolls, setKeepRolls] = useState<any[]>([]);
  const [summon_option_list, setSummonOptionList] = useState<SummonOption2[]>([]);
  const [selected_option, setSelectedOption] = useState<SummonOption2 | null>(null);
  const [selected_id, setSelectedId] = useState("");
  const [selected_creature, setSelectedCreature] = useState<Creature | null>(null);
  const [roll, setRoll] = useState<RolledValue[]>([]);

  const getPotence = useCallback(() => {
    let potence: Potence | undefined = effect.potences[0];
    if (spell) {
      if (log_it) {
        debugger;
      }
      if (spell.level === 0) {
        // For cantrips take the appropriate potence for the creature's CR.
        const max_potence_level = Math.max(...effect.potences.filter(o => o.level <= creature_instance.challenge_rating).map(o => o.level), 1);
        potence = effect.potences.find(o => o.level === max_potence_level);
        if (!potence) {
          potence = effect.potences[0];
        }
      } else if (c_spell) {
        if (c_spell.cast_level && c_spell.cast_level > spell.level) {
          const cast_level = c_spell.cast_level;
          const max_potence_level = Math.max(...effect.potences.filter(o => o.level <= cast_level).map(o => o.level), 1);
          potence = effect.potences.find(o => o.level === max_potence_level);
          if (!potence) {
            potence = effect.potences[0];
          }
        }
      }
    }
    return potence;
  }, [spell, c_spell, effect]);
    
  const load = useCallback( async () => {
    if (effect.type === "Transform") {
      // setLoading(true);
      // const onComplete = (res: SmartHash) => {
      //     setTransforms(res.transform as Transform[]);
      //     setLoading(false);
      // };
      // const onProgress = () => {};
      // api.getSetOfObjectsWithCallbacks({ 
      //   data_types: ["transform"],
      //   onComplete, onProgress 
      // });
    // } else if (effect.type === "Adaptation") {
    //   setLoading(true);
    //   const onComplete = (res: SmartHash) => {
    //     setAdaptations(res.adaptation as Adaptation[]);
    //     setLoading(false);
    //   };
    //   const onProgress = () => {};
    //   api.getSetOfObjectsWithCallbacks({ 
    //     data_types: ["adaptation"],
    //     onComplete, onProgress 
    //   });
    } else if (effect.type === "Summon") {
      const potence = getPotence();
      // let extra_string = "";
      if (potence) {
        // extra_string = potence.extra;
        const options = await char_util.getSummonOption2s(creature_instance, potence);
        setSummonOptionList(options);
      }
    }
    setLoading(false);
  }, []);

  const effectType = useCallback((use_effect: AbilityEffect | null = null) => {
    const effect_type = use_effect ? use_effect.type : effect.type;
    // if (effect_type === "Damage" && spell instanceof CharacterSpell) {
    //   const dt_mods = spell.damage_type_modifications;
    //   if (dt_mods.length > 0) {
    //     return dt_mods[0].detail;
    //   }
    // }
    if (effect_type === "Selectable Key") {
      // const key = effect.selectable_key;
      // let cfs: CharacterFeatureSource | null = null;
      // if (spell) {
      //   switch (spell.source_type) {
      //     case "Race": cfs = creature_instance.race; break;
      //     default:
      //       console.log(spell);
      //       console.log(key);
      //       console.log(effect);
      //       console.log(creature_instance);
      //     break;
      //   }
      // }
      // if (cfs && cfs.selectable_hash[key]) {
      //   effect_type = cfs.selectable_hash[key];
      //   if (effect.selectable_type === "Damage Type" && 
      //     ALL_DRAGONS.includes(effect_type)) {
      //     effect_type = (DRACONIC_DAMAGE_TYPES as any)[effect_type];
      //   }
      // }
    } else if (effect_type === "Use Extra") {
      // if (ee_cf) {
      //   const char_item = creature_instance.all_char_feature_sources.find(o => o.true_id === ee_cf.item_id);
      //   const cmik = creature_instance.all_char_feature_sources.find(o => o.true_id === ee_cf.source_true_id);
      //   if (char_item instanceof CharacterItem && cmik instanceof CharacterMagicItemKeyword) {
      //     if (cmik.source) {
      //       if (cmik.source.extra_base_type === "Dragon Breed") {
      //         effect_type = (DRACONIC_DAMAGE_TYPES as any)[char_item.extra];
      //       } else {
      //         effect_type = char_item.extra;
      //       }
      //     }
      //   }
      // }
    }
    return effect_type;
  }, []);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      setLoading(true);
      setTimeout(() => {
        load();
      }, 100);
    }
  }, [fetched, load]);

  useEffect(() => {
    if (is_processing !== processing) {
      setProcessing(processing);
    }
    // eslint-disable-next-line
  }, [processing]);
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);
  
  useEffect(() => {
    if (action) {
      const potence = getPotence();
      if (potence) {
        const effect_type = effectType();
        if (effect_type === "Transform") {
          // debugger;
          const filtered: Transform[] = []; // api.filter("", transforms, potence.obj_filter);
          // if (potence.knowledge_usage_key.length > 0) {
          //   filtered = filtered.filter(o => 
          //     creature_instance.knowledge.filter(o2 => 
          //       o2.obj_id === o._id && 
          //       o2.type === "Transform" && 
          //       o2.usage === potence.knowledge_usage_key
          //     ).length > 0
          //   );
          // }
          const selected_transform = filtered.length === 1 ? filtered[0] : filtered.find(o => o._id === selected_id);
          if (selected_transform) {
            const costs: { [resource: string]: number } = {};
            costs[action.consumed_resource.resource_consumed] = selected_transform.cost;
            onCostChange(costs);
          }
        }
        //  else if (effect_type === "Adaptation") {
        //   let filtered: Adaptation[] = []; // api.filter("", adaptations, potence.obj_filter);
        //   // if (potence.knowledge_usage_key.length > 0) {
        //   //   filtered = filtered.filter(o => 
        //   //     creature_instance.knowledge.filter(o2 => 
        //   //       o2.obj_id === o._id && 
        //   //       o2.type === "Adaptation" && 
        //   //       o2.usage === potence.knowledge_usage_key
        //   //     ).length > 0
        //   //   );
        //   // }
        //   const selected_adaptation = filtered.length === 1 ? filtered[0] : filtered.find(o => o._id === selected_id);
        //   if (selected_adaptation) {
        //     const costs: { [resource: string]: number } = {};
        //     costs[action.consumed_resource.resource_consumed] = selected_adaptation.cost;
        //     onCostChange(costs);
        //   }
        // }
      }
    }
    // eslint-disable-next-line
  }, [selected_id, setSelectedId, getPotence]);
  
  const enabled = !disabled;

  const renderExtras = () => {
    return [
      <Popover key="rolls"
        open={ popoverAnchorEl !== null && popoverMode !== "Cast" }
        anchorEl={popoverAnchorEl}
        onClose={() => {
          setPopoverAnchorEl(null);
          setPopoverEffect(null);
          setPopoverMode("");
          // setKeepRolls([]);
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        { renderRoll() }
      </Popover>
    ];
  }

  const renderSummonControls = (potence: Potence, extra_string: string) => {
    // const summon_options = potence.summon_options;
    // let summon_option_list: SummonOption2[] = []; 
    // if (summon_options.filter(o => !o.custom).length === 0) {
    //   summon_option_list = potence.summon_option_list([]);
    // }
    // const summon_option_list = char_util.getSummonOption2s(creature_instance, potence);
    const option = summon_option_list.length === 1 ? summon_option_list[0] : selected_option;
    const effect_type = effectType();
    const range_string = effect.range_string; // spell instanceof Attack ? "Self" : char_util.getRangeString({ char_int: creature_instance, spell, effect });
    return (
      <Grid className="centered"
        container spacing={0} direction="row">
        <Grid
          className="centered"
          size={{
            xs: 4
          }}>
          { show_range &&
            <>
              { range_string }{ extra_string !== "" ? (range_string !== "" ? ` / ${extra_string}` : extra_string) : "" }
            </>
          }
        </Grid>
        <Grid
          size={{
            xs: 4
          }}>
          { summon_option_list.length !== 1 ?
            <CharacterSummonOptions 
              name="Choose"
              character={creature_instance}
              // potence={potence}
              value={option}
              summon_option_list={summon_option_list}
              shared={shared}
              onChange={setSelectedOption}
            />
          : option &&
            <span>{ option.name }</span>
          }
        </Grid>
        <Grid
          size={{
            xs: 4
          }}>
          <DandDButtonBox 
            disabled={ !enabled } // || option === null || option === undefined || processing }
            name={effect_type}
            onClick={() => {
              if (option) {
                summonSelected(option);
              }
            }}
          />
        </Grid>
        { renderExtras() }
      </Grid>
    );
  }

  const summonSelected = (selected_option: SummonOption2) => {
    onSummon(selected_option);
  }

  const renderTransformControls = (potence: Potence, extra_string: string) => {
    // if (spell instanceof CharacterAbility && spell.name.includes("Wild")) {
    //   debugger;
    // }
    // console.log(transforms);
    const filtered: Transform[] = []; // api.filter("", transforms, potence.obj_filter);
    // if (filtered.length === 1 && filtered[0] instanceof CreatureTransform) {
    //   // Knowledge is about the Creatures rather than the transforms
    //   // Handled later.
    // } else if (potence.knowledge_usage_key.length > 0) {
    //   // filtered = filtered.filter(o => 
    //   //   creature_instance.knowledge.filter(o2 => 
    //   //     o2.obj_id === o._id && 
    //   //     o2.type === "Transform" && 
    //   //     o2.usage === potence.knowledge_usage_key
    //   //   ).length > 0
    //   // );
    // }
    const selected_transform = filtered.length === 1 ? filtered[0] : filtered.find(o => o._id === selected_id);
    const selected_transform_id = selected_transform ? selected_transform._id : "";
    const range_string = effect.range_string; // spell instanceof Attack ? "Self" : char_util.getRangeString({ char_int: creature_instance, spell, effect });
    const creature_filter: any = {};
    if (selected_transform instanceof CreatureTransform) {
      // const knowledges = creature_instance.knowledge.filter(o2 => 
      //   o2.type === "Creature" && 
      //   o2.usage === selected_transform.knowledge_usage_key
      // );
      // if (knowledges.length > 0) {
      //   creature_filter = {
      //     "_id*ObjectIDs": knowledges.map(o => o.obj_id)
      //   };
      // } else {
      //   creature_filter = char_util.getCreatureFilter(creature_instance, selected_transform, spell);
      // }
    }
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          className="centered"
          size={{
            xs: 4
          }}>
          { show_range &&
            <>
              { range_string }{ extra_string !== "" ? (range_string !== "" ? ` / ${extra_string}` : extra_string) : "" }
            </>
          }
        </Grid>
        { (filtered.length > 1 || !(selected_transform instanceof CreatureTransform)) &&
          <Grid
            className="centered"
            size={{
              xs: 4
            }}>
            { filtered.length === 1 ? 
              <DisplayObjects type="transform" ids={[selected_transform_id]} /> 
            :
              <SelectObjectBox
                name="Transform"
                data_type="transform"
                filter={{ "_id": { "in": filtered.map(o => o._id) }}} 
                value={selected_id}
                onChange={setSelectedId}
              />
            }
          </Grid> 
        }
        { selected_transform instanceof CreatureTransform ? 
          <>
            { filtered.length === 1 && !reloading ? 
              <>
                <Grid
                  className="centered"
                  size={{
                    xs: 4
                  }}>
                  <SelectObjectBox
                    name={ selected_transform.name }
                    data_type="creature"
                    filter={creature_filter} 
                    // internal_filter
                    display_format="{obj.true_name} (CR: {obj.challenge_rating}){obj.flying_string}"
                    // log_it
                    value={selected_creature ? selected_creature._id : ""}
                    onChangeObject={setSelectedCreature}
                  />
                </Grid>
                <Grid
                  className="centered"
                  size={{
                    xs: 4
                  }}>
                  <DandDButtonBox
                    name="Transform"
                    style={{ fontSize: "9" }} 
                    image={ effect.type }
                    disabled={ !enabled || selected_creature === null }
                    onClick={() => {
                      // const transform_id = filtered.length === 1 ? filtered[0]._id : selected_id;
                      // const transform = transforms.find(o => o._id === transform_id);
                      // if (transform instanceof CreatureTransform && selected_creature) {
                      //   // Apply the transform
                      //   char_util.createTransformInstance(creature_instance, transform, selected_creature).then(res => {
                      //     setPing(!ping);
                      //     onTransform();
                      //   });
                      // }
                    }} 
                  />
                </Grid>
              </>
            : !reloading && 
              <>
                <Grid
                  className="centered"
                  size={{
                    xs: 4
                  }}>
                  <DandDButtonBox
                    name="Transform"
                    style={{ fontSize: "9" }} 
                    image={ effect.type }
                    disabled={ !enabled || selected_creature === null }
                    onClick={() => {
                      // const transform_id = filtered.length === 1 ? filtered[0]._id : selected_id;
                      // const transform = transforms.find(o => o._id === transform_id);
                      // if (transform instanceof CreatureTransform && selected_creature) {
                      //   // Apply the transform
                      //   char_util.createTransformInstance(creature_instance, transform, selected_creature).then(res => {
                      //     setPing(!ping);
                      //     onTransform();
                      //   });
                      // }
                    }} 
                  />
                </Grid>
                <Grid
                  className="centered"
                  size={{
                    xs: 12
                  }}>
                  <SelectObjectBox
                    name={ selected_transform.name }
                    data_type="creature"
                    filter={creature_filter} 
                    display_format="{obj.true_name} (CR: {obj.challenge_rating}){obj.flying_string}"
                    value={selected_creature ? selected_creature._id : ""}
                    onChangeObject={setSelectedCreature}
                  />
                </Grid>
              </>
            }
          </>
        :
          <Grid
            className="centered"
            size={{
              xs: 4
            }}>
            <DandDButtonBox
              name="Transform"
              style={{ fontSize: "9" }} 
              image={ effect.type }
              disabled={ !enabled || (filtered.length > 1 && selected_id === "") }
              onClick={() => {
                // const transform_id = filtered.length === 1 ? filtered[0]._id : selected_id;
                // const transform = transforms.find(o => o._id === transform_id);
                // if (transform) {
                //   // Apply the transform
                //   char_util.createTransformInstance(creature_instance, transform).then(res => {
                //     setPing(!ping);
                //     onTransform();
                //   });
                // }
              }} 
            />
          </Grid>
        }
        { renderExtras() }
      </Grid>
    );
  }

  // const renderAdaptationControls = (potence: Potence, extra_string: string) => {
  //   // debugger;
  //   console.log(adaptations);
  //   let filtered: Adaptation[] = []; // api.filter("", adaptations, potence.obj_filter);
  //   const selected_adaptation = filtered.length === 1 ? filtered[0] : filtered.find(o => o._id === selected_id);
  //   return (
  //     <Grid container spacing={0} direction="row">
  //       <Grid item xs={4} className="centered">
  //       { extra_string !== "" ? extra_string : "" }
  //       </Grid>
  //       <Grid item xs={4} className="centered">
  //         { filtered.length === 1 && selected_adaptation ? 
  //           <DisplayObjects type="adaptation" ids={[selected_adaptation._id]} /> 
  //         :
  //           <SelectObjectBox
  //             name="Adaptation"
  //             system="dandd"
  //             data_type="adaptation"
  //             filter={{ "_id": { "in": filtered.map(o => o._id) }}}              
  //             value={selected_id}
  //             display_format={"{obj.name} ({obj.cost})"}
  //             onChange={setSelectedId}
  //           />
  //         }
  //       </Grid>
  //       <Grid item xs={4} className="centered">
  //         <DandDButtonBox
  //           name="Adapt"
  //           style={{ fontSize: "9" }} 
  //           image={ effect.type }
  //           disabled={ !enabled }
  //           onClick={() => {
  //           }} 
  //         />
  //       </Grid>
  //       { renderExtras() }
  //     </Grid>
  //   );
  // }

  const renderCreateResourceControls = (potence: Potence) => {
    // const amount = potence.create_resource.amount;
    // if (spell && !(spell instanceof CharacterItem || spell instanceof Attack)) {
    //   // const effect_type = effectType();
    //   // const flat = char_util.value(amount.flat, { obj: creature_instance, source_id: spell.source_id, root_id: spell.source_id });
    //   // const count = char_util.value(amount.count, { obj: creature_instance, source_id: spell.source_id, root_id: spell.source_id });
    //   // const size = char_util.value(amount.size, { obj: creature_instance, source_id: spell.source_id, root_id: spell.source_id });
    //   // if (size !== null && count !== null && flat !== null) {
    //   //   let str = effect.refresh_only ? "Refresh " : "Create ";
    //   //   if (size > 1 && count > 0) {
    //   //     str += `${count}d${size}` + (flat === 0 ? "" : `+${flat}`) + " ";
    //   //     if (potence.create_resource.resource_type === "Slot") {
    //   //       str += `Level ${ potence.create_resource.level } Slot`;
    //   //     }
    //   //     return (
    //   //       <Grid className="centered"
    //   //         container spacing={0} direction="row">
    //   //         <Grid item xs={4} className="centered">
    //   //           { str }&nbsp;
    //   //           { potence.create_resource.resource_type !== "Slot" &&
    //   //             <DisplayObjects type="resource" ids={[potence.create_resource.resource_type]} />
    //   //           }
    //   //         </Grid>
    //   //         <Grid item xs={4}></Grid>
    //   //         <Grid item xs={4}>
    //   //           <DandDButtonBox 
    //   //             disabled={ !enabled || processing }
    //   //             name={effect_type}
    //   //             onClick={(event: React.MouseEvent<HTMLDivElement>) => {
    //   //               setPopoverEffect(effect);
    //   //               setPopoverMode("Create");
    //   //               setPopoverAnchorEl(event.currentTarget);
    //   //             }}
    //   //           />
    //   //         </Grid>
    //   //         { renderExtras() }
    //   //       </Grid>
    //   //     );
    //   //   } else if (flat) {
    //   //     if (flat > 1) {
    //   //       str += `${flat} `;
    //   //     }
    //   //     if (potence.create_resource.resource_type === "Slot") {
    //   //       str += `Level ${ potence.create_resource.level } Slot`;
    //   //     }
    //   //     return (
    //   //       <Grid className="centered"
    //   //         container spacing={0} direction="row">
    //   //         <Grid item xs={4} className="centered">
    //   //           { str }&nbsp;
    //   //           { potence.create_resource.resource_type !== "Slot" &&
    //   //             <DisplayObjects type="resource" ids={[potence.create_resource.resource_type]} display_field={flat === 1 ? "singular" : "name"} />
    //   //           }
    //   //         </Grid>
    //   //         <Grid item xs={4}></Grid>
    //   //         <Grid item xs={4}>
    //   //           <DandDButtonBox 
    //   //             disabled={ !enabled || processing }
    //   //             name={effect_type}
    //   //             onClick={() => {
    //   //               char_util.createResource(creature_instance, potence, flat, effect.refresh_only);
    //   //               setPing(true);
    //   //               onChange(["Resources"]);
    //   //             }}
    //   //           />
    //   //         </Grid>
    //   //         { renderExtras() }
    //   //       </Grid>
    //   //     );
    //   //   }
    //   // }
    // }
    return null;
  }

  const renderRollableTableControls = () => {
    // debugger;
    return (
      <>
        <CharacterRollableTableEffect
          char={creature_instance}
          shared={shared}
          effect={effect}
        />
        { renderExtras() }
      </>
    );
  }

  const renderSelfConditionControls = () => {
    // if (spell) {
    //   return (
    //     <>
    //       {/* <CharacterSelfConditionEffect
    //         character={creature_instance}
    //         char_interface={char_interface}
    //         spell={spell}
    //         effect={effect}
    //         shared={shared}
    //         onChange={() => {
    //           onChange(["Conditions"]);
    //         }}
    //       />
    //       { renderExtras() } */}
    //     </>
    //   );
    // }
    return <></>;
  }

  const renderEnhanceItem = () => {
    // Select a valid item
    // Apply the mik
    // Also have a button to clear it from all items.
    // debugger;
    // let valid_items = [...creature_instance.items];
    // const potence = spell ? char_util.getPotence({ slot_level: level, char: creature_instance, char_int: char_interface, spell, effect, cfs_id: "", attack_mod, log_it }) : null;
    // if (potence) {
    //   const enhance_item_mik_id = potence.enhance_item_mik_id;
    //   const mik = char_util.magic_item_keywords.find(o => o._id === enhance_item_mik_id);
    //   if (mik) {
    //     if (mik.base_item_ids.length > 0) {
    //       valid_items = valid_items.filter(o => mik.base_item_ids.includes(o.base_item_id));
    //     } else if (mik.base_item_types && mik.base_item_types.length > 0) {
    //       valid_items = valid_items.filter(o => mik.base_item_types.includes(o.item_type));
    //     }
    //     return (
    //       <Grid container spacing={0} direction="row">
    //         <Grid item xs={4}>

    //         </Grid>
    //         <Grid item xs={8} container spacing={0} direction="row">
    //           <Grid item xs={6}>
    //             <SelectCharacterItemBox 
    //               name="Selected Item"
    //               value={selected_id}
    //               character={creature_instance}
    //               objects={valid_items}
    //               onChange={setSelectedId}
    //             />
    //           </Grid>
    //           <Grid item xs={3}>
    //             <DandDButtonBox
    //               name={ `Apply` }
    //               disabled={ !enabled || selected_id === "" }
    //               onClick={() => {
    //                 const char_item = valid_items.find(o => o.true_id === selected_id);
    //                 if (char_item) {
    //                   // char_item.magic_item_keyword_ids.push(mik._id);
    //                   char_util.connectMagicItemKeyword({
    //                     char: creature_instance, 
    //                     char_item_or_id: char_item, 
    //                     magic_item_keyword_or_id: mik._id, 
    //                     source_id: spell?.source_id??"",
    //                     char_feature_id: ""
    //                   });
    //                   onChange(["Items"]);
    //                 }
    //               }} 
    //             />
    //           </Grid>
    //           <Grid item xs={3}>
    //             <DandDButtonBox
    //               name={ `Remove All` }
    //               disabled={ !enabled || valid_items.filter(o => 
    //                 o.magic_item_keyword_ids.includes(mik._id)).length === 0 }
    //               onClick={() => {
    //                 // debugger;
    //                 for (const char_item of valid_items.filter(o => 
    //                   o.magic_item_keyword_ids.includes(mik._id))) {
    //                   if (char_item) {
    //                     char_item.sub_char_feature_sources = 
    //                       char_item.sub_char_feature_sources.filter(o => o.source_id !== mik._id);
    //                     // char_item.magic_item_keyword_ids = char_item.magic_item_keyword_ids.filter(o => o !== mik._id);
    //                   }
    //                 }
    //                 onChange(["Items"]);
    //               }} 
    //             />
    //           </Grid>
    //         </Grid>
    //       </Grid>
    //     );
    //   }
    // }
    return <></>;
  }

  const renderCreateItem = () => {
    // debugger;
    // if (spell instanceof CharacterAbility) {
    //   const potence = effect.potences[0]; // spell ? char_util.getPotence({ slot_level: level, char: creature_instance, char_int: char_interface, spell, effect, cfs_id: "", attack_mod, log_it }) : null;
    //   if (potence) {
    //     let pseudo_item_ids: string[] = [];
    //     if (potence.create_item.item_creation_type === "Specific") {
    //       pseudo_item_ids = potence.create_item.pseudo_item_ids;
    //     } else if (potence.create_item.item_creation_type === "Knowledge") {
    //       console.error("Not Implemented");
    //     } else {
    //       if (effect.selectable_key !== "") {
    //         // const cfs = creature_instance.all_char_feature_sources.find(o => o.true_id === spell.source_true_id);
    //         // if (cfs) {
    //         //   pseudo_item_ids = [cfs.selectable_hash[effect.selectable_key]];
    //         // }
    //       }
    //     }
    //     if (pseudo_item_ids.length === 1) {
    //       const pseudo_item = char_util.getPseudoItem(pseudo_item_ids[0]);
    //       if (pseudo_item) {
    //         return (
    //           <Grid container spacing={0} direction="row">
    //             <Grid item xs={4}>

    //             </Grid>
    //             <Grid item xs={8} container spacing={0} direction="row">
    //               <Grid item xs={6}>
    //                 <ViewItem
    //                   item={pseudo_item}
    //                 />
    //               </Grid>
    //               <Grid item xs={3}>
    //                 <DandDButtonBox
    //                   name={ `Create` }
    //                   disabled={ !enabled }
    //                   onClick={() => {
    //                     // char_util.addItem(creature_instance, pseudo_item, char_util.all_feature_sources, 1).then(res => {
    //                     //   onChange(["Items"]);
    //                     // });
    //                   }} 
    //                 />
    //               </Grid>
    //               <Grid item xs={3}>
    //                 <DandDButtonBox
    //                   name={ `Remove All` }
    //                   disabled={ !enabled }
    //                   onClick={() => {
    //                     // debugger;
    //                     // for (const char_item of valid_items.filter(o => 
    //                     //   o.magic_item_keyword_ids.includes(mik._id))) {
    //                     //   if (char_item) {
    //                     //     char_item.sub_char_feature_sources = 
    //                     //       char_item.sub_char_feature_sources.filter(o => o.source_id !== mik._id);
    //                     //     // char_item.magic_item_keyword_ids = char_item.magic_item_keyword_ids.filter(o => o !== mik._id);
    //                     //   }
    //                     // }
    //                     onChange(["Items"]);
    //                   }} 
    //                 />
    //               </Grid>
    //             </Grid>
    //           </Grid>
    //         );
    //       }
    //     } else {
    //       return <>Not Implemented</>;
    //     }
    //   }
    // }
    return <></>;
  }

  const renderRoll = () => {
    if (popoverAnchorEl !== null && popoverMode !== "Cast") {
      // debugger;
      const mode = popoverMode;
      const effect = popoverEffect;
      // const advantage = false; // const { advantage } = char_util.getAdvantage(creature_instance, "Attack", spell);
      if (effect) {
        const effect_type = effectType();
        if (mode === "Attack") {
          // const attack_roll = new RollPlus();
          // attack_roll.flat = spell ? creature_instance.current_ability_scores.getModifier(creature_instance.spellcasting_ability) : 0;
          // attack_roll.size = 20;
          // attack_roll.count = 1;
          return (
            <Roller 
              name={ spell ? spell.name : (action ? action.name : "") }
              rolled_values={roll} 
              type="Attack" 
            />
          );
        } else if (mode === "Damage") {
          // const potence = effect.potences[0]; // char_util.getPotence({ slot_level: level, char: creature_instance, char_int: char_interface, spell: (ee_cf && (ee_cf.floating_feature instanceof ExtraEffectsFeature || ee_cf.floating_feature instanceof ExtraEffectsOfTypeFeature) ? ee_cf : ability), effect, cfs_id: (ee_cf ? ee_cf.source_id : ""), attack_mod });
          // let damage_rolls: RollPlus[] = [];
          // if (potence) {
          //   const roll_plus = char_util.toRollPlus(potence.rolls, { 
          //     obj: creature_instance,
          //     source_id: "", //ability.source_id, 
          //     base_slot_level: spell.level, 
          //     slot_level: level, 
          //   });
          //   damage_rolls.push(roll_plus);
          // }
          // damage_rolls = [...damage_rolls,...ability.attack.damage_rolls];
          
          // const rerolls: Reroll[] = [];
          if (effect_type === "Healing" || effect_type === "Temp HP" || effect_type === "Max HP") {
            return (
              <Roller 
                name={ spell ? spell.name : (action ? action.name : "") }
                rolled_values={roll} 
                type={effect_type} 
                // onApply={(total: number, roll_renders: any[]) => {
                //   if (effect_type === "Healing") {
                //     creature_instance.hp.current += total;
                //     const max_hit_points = (creature_instance.hp.override_max === -1 ? creature_instance.hp.max : creature_instance.hp.override_max) + creature_instance.hp.max_modifier;
                //     if (creature_instance.hp.current > max_hit_points) {
                //       creature_instance.hp.current = max_hit_points;
                //     }
                //   } else if (effect_type === "Temp HP") {
                //     if (creature_instance.hp.temp < total) {
                //       creature_instance.hp.temp = total;
                //     }
                //   } else if (effect_type === "Max HP") {
                //     creature_instance.hp.max_modifier += total;
                //     creature_instance.hp.current += total;
                //   }
                //   // char.create_resource(potence, total, effect.refresh_only);
                //   setPing(!ping);
                //   setKeepRolls(roll_renders);
                //   onChange(["Health"]);
                // }}
              />
            );
          } else {
            let name = spell ? spell.name : (action ? action.name : "");
            const dt_override_name_change = dt_overrides.find(o => o.name_formula !== "");
            if (dt_override_name_change) {
              let new_name = dt_override_name_change.name_formula;
              if (new_name.includes("replace.")) {
                // debugger;
                // {replace.Dragon.Shadow Dragon}
                new_name = new_name.replace("{","").replace("}","");
                const pieces = new_name.split(".");
                if (pieces.length === 3) {
                  new_name = name.replace(pieces[1], pieces[2]);
                }
              } else {
                new_name = new_name.replace("{base.name}", name);
              }
              name = new_name;
            }
            return (
              <Roller 
                name={ name }
                rolled_values={roll} 
                type="Damage" 
              />
            );
          }
        } else if (mode === "Create") {
          console.log("Not Implemented");
        }
      }
    }
    return null;
  }

  if (!fetched || loading) {
    return (<LoadingBox />);
  } else {
    const effect_type = effectType();
    if (action && log_it) {
      console.log(action);
      console.log(effect_type);
    }
    if (["Rollable Table"].includes(effect_type)) {
      return renderRollableTableControls();
    } else if (["Self Condition"].includes(effect_type)) {
      return renderSelfConditionControls();
    } else if (["Enhance Item"].includes(effect_type)) {
      return renderEnhanceItem();
    } else if (["Create Item"].includes(effect_type)) {
      return renderCreateItem();
    } else {
      // const potence = effect.potences.length > 0 ? effect.potences[0] : null;
      const potence = getPotence();
      let extra_string = "";
      if (potence) {
        extra_string = potence.extra;
        if (["Summon"].includes(effect.type)) {
          return renderSummonControls(potence, extra_string);
        } else if (effect.type === "Transform") {
          return renderTransformControls(potence, extra_string);
        // } else if (effect.type === "Adaptation") {
        //   return renderAdaptationControls(potence, extra_string);
        } else if (effect_type === "Create Resource") {
          return renderCreateResourceControls(potence);
        }
      }
      let potence_string = "";
      if (isSpellLevel(level)) {
        if (spell) {
          potence_string = char_util.getPotenceString({slot_level: level, char_int: creature_instance, spell, potence, item_id: "", effect, cfs_id: "", attack_mod}); // , log_it
        } else if (action) {
          potence_string = char_util.getPotenceString({slot_level: level, char_int: creature_instance, spell: action, potence, item_id: "", effect, cfs_id: "", attack_mod}); // , log_it
        }
      }
      const range_string = effect.range_string; 
      let spell_attack = 0;
      let spell_dc = 0;
      if (action instanceof CreatureAbility) {
        spell_attack = char_util.value(action.attack_bonus, { obj: creature_instance });
        spell_dc = char_util.value(action.dc, { obj: creature_instance });
      } else if (spell) {
        spell_attack = char_util.value(creature_instance.spell_attack, { obj: creature_instance });
        spell_dc = char_util.value(creature_instance.spell_dc, { obj: creature_instance });
      }
      let damage_types = effect.damage_types;
      const override = dt_overrides.find(o => o.to_damage_type !== "None" && common_util.anyOverlaps(damage_types, o.from_damage_types));
      if (override && override.to_damage_type !== "None") {
        damage_types = [override.to_damage_type];
      }
      return (
        <Grid container spacing={0} direction="row" 
          // style={{ minHeight: "37.5px"}}
          >
          <Grid
            className="centered"
            size={{
              xs: 4
            }}>
            { show_range && (!["Control","Utility"].includes(effect_type) || 
              !["","Utility"].includes(effect.utility_detail)) &&
              <>
                { range_string }{ extra_string !== "" ? (range_string !== "" ? ` / ${extra_string}` : extra_string) : "" }
              </>
            }
          </Grid>
          <Grid size={4} className="centered">
            { effect.use_attack ?
              <DandDButtonBox
                name={ common_util.addPlusMaybe(spell_attack) }
                // advantage={ advantage }
                // advantages={ advantages }
                disabled={ !enabled }
                // minimum_roll={minimum_roll}
                onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                  const attack_roll = new RollPlus();
                  attack_roll.flat = spell_attack;
                  // debugger;
                  const new_roll = char_util.rollD20({ char_interface: creature_instance, rolls: [attack_roll], type: "Attack" });
                  setRoll(new_roll);
                  setPopoverEffect(effect);
                  setPopoverMode("Attack");
                  setPopoverAnchorEl(event.currentTarget);
                }} 
              />
            : effect.attack_type === "Save" &&
              <span>
                { `${effect.saving_throw_ability_score} ${spell_dc}` }
              </span> 
            }
          </Grid>
          <Grid
            className="centered"
            size={{
              xs: 4
            }}>
            { effect_type === "Damage" && damage_types.length < 2 ?
              <DandDButtonBox
                name={ potence_string }
                style={{ fontSize: "9" }}                          
                image={ damage_types.length > 0 ? damage_types[0] : "" }
                disabled={ !enabled }
                onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                  if (potence_string === "Apply") {
                    // const self_condition_ids = effect.conditions_applied;
                    // if (self_condition_ids.length > 0) {
                    //   // Apply the conditions
                    //   // const character = char;
                    //   // self_condition_ids.forEach(cond_id => {
                    //   //   character.conditions.push(cond_id);
                    //   // });
                    //   setPing(!ping);
                    //   onChange([]);
                    //   // updateCharacter(["Condition"]);
                    // }
                  } else {
                    const effect_type = effectType(effect);
                    const potence = getPotence(); // char_util.getPotence({ slot_level: level, char: creature_instance, char_int: char_interface, spell: (ee_cf && (ee_cf.floating_feature instanceof ExtraEffectsFeature || ee_cf.floating_feature instanceof ExtraEffectsOfTypeFeature) ? ee_cf : ability), effect, cfs_id: (ee_cf ? ee_cf.source_id : ""), attack_mod });
                    const damage_rolls: RollPlus[] = [];
                    if (potence) {
                      const roll_plus = char_util.toRollPlus(potence.rolls, { 
                        obj: creature_instance,
                        source_id: "", //ability.source_id, 
                        base_slot_level: spell ? spell.level : 1, 
                        slot_level: level, 
                      });
                      damage_rolls.push(roll_plus);
                    }
                    if (effect_type === "Healing" || effect_type === "Temp HP" || effect_type === "Max HP") {
                      setRoll(char_util.rollOther({ char_interface: creature_instance, rolls: damage_rolls, type: effect_type }));
                    } else {
                      setRoll(char_util.rollOther({ char_interface: creature_instance, rolls: damage_rolls, type: "Damage" }));
                    }
                    setPopoverEffect(effect);
                    setPopoverMode("Damage");
                    setPopoverAnchorEl(event.currentTarget);
                  }
                }} 
              />
            : effect_type === "Damage" && damage_types.length > 1 ?
              <Grid container spacing={0} direction="row">
                <Grid
                  size={{
                    xs: 12
                  }}>
                  <DandDButtonBox
                    name={ potence_string }
                    style={{ fontSize: "9" }}                          
                    image={ damage_types[0] }
                    disabled={ !enabled }
                    onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                      // debugger;
                      if (potence_string === "Apply") {
                        // const self_condition_ids = effect.conditions_applied;
                        // if (self_condition_ids.length > 0) {
                        //   // Apply the conditions
                        //   // const character = char;
                        //   // self_condition_ids.forEach(cond_id => {
                        //   //   character.conditions.push(cond_id);
                        //   // });
                        //   setPing(!ping);
                        //   onChange([]);
                        //   // updateCharacter(["Condition"]);
                        // }
                      } else {
                        const effect_type = effectType(effect);
                        const potence = getPotence(); // char_util.getPotence({ slot_level: level, char: creature_instance, char_int: char_interface, spell: (ee_cf && (ee_cf.floating_feature instanceof ExtraEffectsFeature || ee_cf.floating_feature instanceof ExtraEffectsOfTypeFeature) ? ee_cf : ability), effect, cfs_id: (ee_cf ? ee_cf.source_id : ""), attack_mod });
                        const damage_rolls: RollPlus[] = [];
                        if (potence) {
                          const roll_plus = char_util.toRollPlus(potence.rolls, { 
                            obj: creature_instance,
                            source_id: "", //ability.source_id, 
                            base_slot_level: spell ? spell.level : 1, 
                            slot_level: level, 
                          });
                          damage_rolls.push(roll_plus);
                        }
                        if (effect_type === "Healing" || effect_type === "Temp HP" || effect_type === "Max HP") {
                          setRoll(char_util.rollOther({ char_interface: creature_instance, rolls: damage_rolls, type: effect_type }));
                        } else {
                          setRoll(char_util.rollOther({ char_interface: creature_instance, rolls: damage_rolls, type: "Damage" }));
                        }
                        setPopoverEffect(effect);
                        setPopoverMode("Damage");
                        setPopoverAnchorEl(event.currentTarget);
                      }
                    }} 
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12
                  }}>
                  { damage_types.map((dt, key) => {
                    return <span key={key}><ImageFromString image={dt} />&nbsp;</span>;
                  })}
                </Grid>
              </Grid>
            : !["Control","Utility","Summon","Transform","Create Resource","Teleport","None"].includes(effect_type) ?
              <DandDButtonBox
                name={ potence_string }
                style={{ fontSize: "9" }}                          
                image={ effect_type }
                disabled={ !enabled }
                onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                  if (potence_string === "Apply") {
                    // const self_condition_ids = effect.conditions_applied;
                    // if (self_condition_ids.length > 0) {
                    //   // Apply the conditions
                    //   // const character = char;
                    //   // self_condition_ids.forEach(cond_id => {
                    //   //   character.conditions.push(cond_id);
                    //   // });
                    //   setPing(!ping);
                    //   onChange([]);
                    //   // updateCharacter(["Condition"]);
                    // }
                  } else {
                    const effect_type = effectType(effect);
                    const potence = getPotence(); // char_util.getPotence({ slot_level: level, char: creature_instance, char_int: char_interface, spell: (ee_cf && (ee_cf.floating_feature instanceof ExtraEffectsFeature || ee_cf.floating_feature instanceof ExtraEffectsOfTypeFeature) ? ee_cf : ability), effect, cfs_id: (ee_cf ? ee_cf.source_id : ""), attack_mod });
                    const damage_rolls: RollPlus[] = [];
                    if (potence) {
                      const roll_plus = char_util.toRollPlus(potence.rolls, { 
                        obj: creature_instance,
                        source_id: "", //ability.source_id, 
                        base_slot_level: spell ? spell.level : 1, 
                        slot_level: level, 
                      });
                      damage_rolls.push(roll_plus);
                    }
                    if (effect_type === "Healing" || effect_type === "Temp HP" || effect_type === "Max HP") {
                      setRoll(char_util.rollOther({ char_interface: creature_instance, rolls: damage_rolls, type: effect_type }));
                    } else {
                      setRoll(char_util.rollOther({ char_interface: creature_instance, rolls: damage_rolls, type: "Damage" }));
                    }
                    setPopoverEffect(effect);
                    setPopoverMode("Damage");
                    setPopoverAnchorEl(event.currentTarget);
                  }
                }} 
              />
            : ["Control","Utility"].includes(effect_type) && 
              effect.utility_detail !== "" && effect.utility_detail !== "Utility" ?
              <span>
                { effect.utility_detail }
              </span> 
            : !["Control","Utility"].includes(effect_type) &&
              <span>
                { effect_type }
              </span> 
            }
          </Grid>
          { renderExtras() }
        </Grid>
      );
    }
  }
}
